import { useCardContext } from '../../../context/CardContext';
import { ChickletSecondaryDisplayLabels } from '../../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../../extensions/hooks/useBehavior';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import ChickletFormattedProperty from '../../../card/secondaryProperties/ChickletFormattedProperty';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderSecondaryProperty = ({
  properties,
  copyDisabled,
  object,
  objectTypeId,
  propertyDefinitions,
  propertyFormatters,
  propertyName
}) => {
  const propertyDefinition = propertyDefinitions === null || propertyDefinitions === void 0 ? void 0 : propertyDefinitions.find(definition => definition.property.name === propertyName);
  if (!propertyDefinition) {
    return null;
  }
  const propertyValue = getPropertyValueFromProperties(properties, propertyName);
  return /*#__PURE__*/_jsx(ChickletFormattedProperty, {
    copyDisabled: copyDisabled,
    getAdditionalPropertyValue: additionalPropertyName => getPropertyValueFromProperties(properties, additionalPropertyName),
    objectId: `${object.objectId}`,
    objectTypeId: objectTypeId,
    propertyDefinition: propertyDefinition.property,
    propertyFormatters: propertyFormatters || {},
    propertyName: propertyName,
    propertyValue: propertyValue
  }, propertyName);
};
function AssociationChicletProperties({
  association
}) {
  const {
    hasScope,
    isUngated,
    propertyDefinitions,
    propertyNames,
    readOnly,
    onEmailClick,
    onPhoneClick,
    onPreview,
    fromObjectId,
    fromObjectTypeId,
    toObjectTypeId
  } = useCardContext();
  const getChickletSecondaryDisplayLabels = useBehavior(ChickletSecondaryDisplayLabels, toObjectTypeId, hasScope, isUngated);
  const {
    propertyFormatters,
    copyDisabled,
    additionalPostfixContent,
    hideSecondaryDisplayLabels
  } = getChickletSecondaryDisplayLabels({
    toObjectTypeId,
    object: association,
    objectId: association.objectId,
    properties: association.properties,
    propertyDefinitions,
    readOnly,
    isUngated,
    onEmailClick,
    onPhoneClick,
    onPreview,
    hasScope,
    fromObjectId,
    fromObjectTypeId
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [!hideSecondaryDisplayLabels && propertyNames.map(propertyName => {
      return /*#__PURE__*/_jsx(View, {
        children: renderSecondaryProperty({
          properties: association.properties,
          copyDisabled,
          object: association,
          objectTypeId: toObjectTypeId,
          propertyDefinitions,
          propertyFormatters,
          propertyName
        })
      }, propertyName);
    }), additionalPostfixContent]
  });
}
export default AssociationChicletProperties;